function getCurrentDate(){
    var d = new Date()
    return [d.getMonth() + 1, d.getDate(), d.getFullYear()].join('-') + ' ' + [d.getHours(), d.getMinutes(), d.getSeconds()].join(':')
}

function isAuthorized(keycloak, role, client) {
    if (keycloak) {
        return keycloak.hasResourceRole(role, client)
    }
    return false;

}



export { getCurrentDate, isAuthorized };